import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";

import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import * as FileSaver from "file-saver";
//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Alert from "reactstrap/lib/Alert";
import styled, { css } from "styled-components";
import exportToCSV from '../../../Common/exportcsv';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';



var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var assign_arr = [];
var unassign_arr = [];
var data_type = "";
const Heading = [['ID','Sku', 'Basepack code',  'Product Name', 'Unit/Case',  'Product Sub Division', 'Product Category', 'Sub Category', 'Sub Putaway Group' , 'Non-PTL', 'MRP'  ,'Sku Weight',  'Sku Volume', 'Carton Weight(Kg)',  'Carton Length(FT)',  'Carton Breadth(FT)', 'Carton Height(FT)', 'Carton Volume(CFT)' ,'Author Id', 'Created Date', 'Brand','Updated By','Shelf Life', 'Mrsl(%)', 'Fragile Item']]


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.toggle = this.toggle.bind(this);


    this.state = {
      ShowpopupLoader: false,
      showFilter: false,
      ShowConfirmLoader: false,
      isDisabledSearch: false,
      showConfirmError: false,
      order: [],
      row_data: [],
      arr_data: [],
      isDisabledApply: false,
      disabledcheck: false,
      showTable: false,
      showFetchDispatchData: false,
      selectedStation: "",
      disabledBtn: false,
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      isChecked: false,
      filtered_orderData: [],
    };
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    sessionStorage.setItem("PUstore_id", "");
    sessionStorage.setItem("PUpolaris_id", "");
    sessionStorage.setItem("PUstatus_type", "");
    sessionStorage.setItem("PUtask_type_value", "");
    sessionStorage.setItem("PUtask_id", "");

    /* sessionStorage.setItem('store_id', this.state.store_id)
    sessionStorage.setItem('polaris_id', this.state.polaris_id)
    sessionStorage.setItem('status_type', this.state.status_type)
    sessionStorage.setItem('task_type_value', this.state.task_type_value)
    sessionStorage.setItem('task_id', this.state.task_id)
*/

    var cookieUsername = Util.getCookie("token");
    var Location = Util.getCookie("selectedLocation");
    var username = Util.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
        store_id:
          sessionStorage.getItem("store_id") == "null"
            ? ""
            : sessionStorage.getItem("store_id"),
        polaris_id:
          sessionStorage.getItem("polaris_id") == "null"
            ? ""
            : sessionStorage.getItem("polaris_id"),
        task_id:
          sessionStorage.getItem("task_id") == "null"
            ? ""
            : sessionStorage.getItem("task_id"),
        status_type:
          sessionStorage.getItem("status_type") == "null" ||
          sessionStorage.getItem("status_type") == ""
            ? "1"
            : sessionStorage.getItem("status_type"),
        task_type_value:
          sessionStorage.getItem("task_type_value") == "null"
            ? ""
            : sessionStorage.getItem("task_type_value"),
      },
      () => {
        this.fetchDispatch();
      }
    );
  }

 

 

  fetchDispatch = (order_no) => {
    this.setState({
      loading_overlay: true,
      loading: true,
    });

       const payload={ 
        master_type: "sku_master",
      }
API.post("/jogeshwari/details/v1/", { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          showFetchDispatchData: true,
          loading: false,
        });

       const updatedData = data.data.map(item => {
        // Log the value of fragile for debugging
       

        // Convert fragile to an integer and then check the value
        const fragileValue = parseInt(item.fragile, 10);

        if (fragileValue === 0) {
          item.fragile = "No";
        } else if (fragileValue === 1) {
          item.fragile = "Yes";
        }

        return item;
      });

        

        this.setState({
          orderData: updatedData,
          filtered_orderData : updatedData,
          tableRowsMap: this.assembleDispatchData(updatedData),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function (error) {});
  };

  assembleDispatchData = (dispatchData) => {
    

    let DispatchData = dispatchData.map((post, index) => {
      return {
        sku: post.sku,
        base_pack_code: post.base_pack_code,
        product_name: post.product_name,
        unit: post.unit,
        sub_division: post.sub_division,
        product_category: post.product_category,
        sub_category: post.sub_category,
        sub_putaway_group: post.sub_putaway_group,
        mrp: post.mrp,
        non_ptl: post.non_ptl.toString(),
        sku_weight: post.sku_weight,
        sku_volume: post.sku_volume,
        carton_weight: post.carton_weight,
        carton_length: post.carton_length,
        carton_breadth: post.carton_breadth,
        carton_height: post.carton_height,
        carton_volume: post.carton_volume,
        author_uid: post.author_uid,
        created_date: post.created_date,
        brand: post.brand,
        upc_updated_by: post.updated_by,
        shelf_life : post.shelf_life,
        mrsl : post.mrsl,
        fragile_item: post.fragile,
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData });
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2 } = this.state;
    const { SuccessConfirmmodal, Failedmodal } = this.state;

    const dispatchData = {
      columns: [
        {
          label: "Sku",

          field: "sku",
          width: 200,
        },

        {
          label: "Basepack code",

          field: "base_pack_code",
          width: 200,
        },
        {
          label: "Product Name",

          field: "product_name",
          width: 300,
        },
        {
          label: "Unit/Case",

          field: "unit",
          width: 200,
        },
        {
          label: "Product Sub Division",

          field: "sub_division",
          width: 200,
        },
        {
          label: "Product Category",

          field: "product_category",
          width: 200,
        },
        {
          label: "Sub Category",

          field: "sub_category",
          width: 200,
        },
        {
          label: "Sub Putaway Group",

          field: "sub_putaway_group",
          width: 200,
        },
        {
          label: "MRP",

          field: "mrp",
          width: 100,
        },
         {
          label: "Non-PTL",

          field: "non_ptl",
          width: 100,
        },
        {
          label: "Sku Weight",

          field: "sku_weight",
          width: 200,
        },
        {
          label: "Sku Volume",

          field: "sku_volume",
          width: 200,
        },
        {
          label: "Carton Weight(Kg)",

          field: "carton_weight",
          width: 200,
        },
        {
          label: "Carton Length(FT)",

          field: "carton_length",
          width: 200,
        },
        {
          label: "Carton Breadth(FT)",

          field: "carton_breadth",
          width: 200,
        },
        {
          label: "Carton Height(FT)",

          field: "carton_height",
          width: 200,
        },
        {
          label: "Carton Volume(CFT)",

          field: "carton_volume",
          width: 200,
        },
        {
          label: "Author Id",

          field: "author_id",
          width: 200,
        },
        {
          label: "Created Date",

          field: "created_date",
          width: 200,
        },
        {
          label: "Brand",

          field: "brand",
          width: 200,
        },
        {
          label: "UPC Updated By",

          field: "upc_updated_by",
          width: 200,
        },
        {
          label: "Shelf Life(months)",

          field: "shelf_life",
          width: 140,
        },
        {
          label: "MRSL(%)",

          field: "mrsl",
          width: 120,
        },

        {
          label: "Fragile Item",

          field: "fragile_item",
          width: 120,
        },
      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          {this.state.showFetchDispatchData && (
            <CardBody style={{ marginTop: 2, paddingTop: 0, paddingBottom: 0 }}>
              <div
                className="table_header"
                style={{ borderBottomWidth: "0px" }}
              >
                <h4
                  style={{
                    fontWeight: "bold",
                    width: "80%",
                    paddingTop: 10,
                    float: "left",
                  }}
                  className="subhead red-text"
                >
                  SKU7 Master
                </h4>

                <span
                  className="pull-right"
                  onClick={() =>
                    exportToCSV(this.state.filtered_orderData, "Sku7 Master", Heading)
                  }
                  style={{
                    fontSize: "17px",
                    paddingRight: "0px",
                    cursor: "pointer",
                    color: "#919193",
                    paddingTop: "9px",
                  }}
                >
                  <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                </span>
              </div>
              <hr style={{ marginTop: "30px", marginBottom: "0px" }} />

              <div className="dispatchData stock_check_data">
                <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="390px"
                  sortable={false}
                  displayEntries={false}
                  striped
                  bordered
                  onSearch={this.filterData}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'SKU7_master_view', 'datatable_pagination_change' )}
                  data={dispatchData}
                />
              </div>
            </CardBody>
          )}
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));